module.exports = __webpack_public_path__ + "img/SCAN_REGISTRATION.ecbff0be.png";